import { createSelector } from 'reselect'

import { selectSelfServiceConfig } from 'selectors/selectSelfServiceConfig'

export const selectSelfServiceIsSecure = createSelector(
  [selectSelfServiceConfig],
  (selfServiceConfig) => selfServiceConfig.get('is_secure') || false
)
